@if (vm$ | async; as vm) {
@if (eposMode) {
<app-price-container-line name="Tax" key="tax-value" [value]="vm.tax" [currency]="currency"
  [currencyRate]="currencyRate" [loading]="vm.loading"></app-price-container-line>
<app-price-container-line name="Total" key="total-value" [value]="vm.total" [currency]="currency"
  [currencyRate]="currencyRate" [loading]="vm.loading"></app-price-container-line>

<app-price-container-line name="Balance" key="balance-value" [value]="vm.balance" [currency]="currency"
  [currencyRate]="currencyRate" [loading]="vm.loading"></app-price-container-line>
} @else {
<div class="flex flex-col gap-y-6">
  <div class="flex flex-col border border-gray-300 gap-y-4 p-3">
    <h2 class="text-center">Charges</h2>
    <app-price-container-line name="Delivery" key="delivery-value" [value]="vm.deliverySubTotal" [currency]="currency"
      [currencyRate]="currencyRate" [loading]="vm.loading"></app-price-container-line>
    <app-price-container-line name="Sub total" key="subtotal-value" [value]="vm.itemsSubTotal" [currency]="currency"
      [currencyRate]="currencyRate" [loading]="vm.loading"></app-price-container-line>
    <app-price-container-line name="Tax" key="tax-value" [value]="vm.tax" [currency]="currency"
      [currencyRate]="currencyRate" [loading]="vm.loading"></app-price-container-line>
    @if(enableDiscount) {
    <div class="flex flex-row justify-start items-center gap-x-4">
      <app-price-container-line name="Discount" key="discount-value" [value]="vm.discount" [currency]="currency"
        [currencyRate]="currencyRate" [loading]="vm.loading"></app-price-container-line>
      <button mat-icon-button (click)="editDiscount.emit()"><mat-icon>edit_pencil</mat-icon></button>
    </div>
    }
    <app-price-container-line name="Total" key="total-value" [value]="vm.total" [currency]="currency"
      [currencyRate]="currencyRate" [loading]="vm.loading"></app-price-container-line>
    @if (shouldShowRoundTotalButton()) {
    <button mat-stroked-button (click)="showRoundDialog.emit()">
      Round Total
    </button>
    }
  </div>
  <div class="flex flex-col border border-gray-300 gap-y-4 p-3">
    <h2 class="text-center">Payments</h2>
    <app-price-container-line name="Paid" key="paid-value" [value]="vm.totalPaid" [currency]="currency"
      [currencyRate]="currencyRate" [loading]="vm.loading"></app-price-container-line>
    <app-price-container-line name="Balance" key="balance-value" [value]="vm.balance" [currency]="currency"
      [currencyRate]="currencyRate" [loading]="vm.loading"></app-price-container-line>
    <div class="flex flex-row justify-center items-center">
      <button *ngIf="canAddPayments; else noAddPayments" mat-raised-button data-cy="add-payment"
        (click)="viewAddPaymentDialog()">
        Add/View Payments
      </button>
      <ng-template #noAddPayments>
        <p data-cy="cannot-add-payments-message" class="text-center">
          <em>You must finalize this invoice before adding payments</em>
        </p>
      </ng-template>
    </div>
  </div>
</div>
}
}